var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import SearchConfigurationService from './SearchConfigurationService';
const setEndpoint = () => {
    switch (SearchConfigurationService.get('environment').toLowerCase()) {
        case 'test':
        case 'ontwikkel':
            window.hexia.overrideEndpoint('searchV2', 'https://search-test.hexia.io/api/v2/');
            break;
        case 'acceptatie':
            window.hexia.overrideEndpoint('searchV2', 'https://search-acc.hexia.io/api/v2/');
            break;
    }
};
const replaceAbsoluteToRelativeUrls = (data) => {
    if (data.hits.hits) {
        data.hits.hits.forEach((hit) => {
            if (!hit._source.url.includes('blob.core.windows.net')) {
                // Gets the domain from an URL without trailing slash and removes it from the url.
                hit._source.url = hit._source.url.replace(/^.+?[^\/:](?=[?\/]|$)/, '');
            }
        });
    }
    return data;
};
const getDefaultParams = (query) => {
    const searchQuery = typeof query === 'object' && query !== null ? query : query ? { q: query, size: 100 } : {};
    return [
        SearchConfigurationService.get('client'),
        SearchConfigurationService.get('index'),
        SearchConfigurationService.get('indexType'),
        SearchConfigurationService.get('searchType'),
        searchQuery,
        SearchConfigurationService.get('language'),
    ];
};
const SearchApiService = {
    searchWithFacets: (query, settingKey, languagePath, facetsToBypass = [], token) => __awaiter(void 0, void 0, void 0, function* () {
        yield SearchConfigurationService.init(settingKey, languagePath);
        setEndpoint();
        token && window.hexia.searchV2.query.setToken(token);
        return replaceAbsoluteToRelativeUrls((yield window.hexia.searchV2.query.facets(...getDefaultParams(query), facetsToBypass, true)).data);
    }),
    search: (query, settingKey, languagePath, token) => __awaiter(void 0, void 0, void 0, function* () {
        yield SearchConfigurationService.init(settingKey, languagePath);
        setEndpoint();
        token && window.hexia.searchV2.query.setToken(token);
        return replaceAbsoluteToRelativeUrls((yield window.hexia.searchV2.query.search(...getDefaultParams(query))).data);
    }),
};
export default SearchApiService;
